module.exports = __webpack_public_path__ + "static/media/30OIOS6.3488d892.jpg";